/**
 * Router which renders views related to `User` models.
 * @module app/routers/admin/Users
 */
import RouterBase from "app/routers/RouterBase";
import $ from "jquery";
import _ from "underscore";
import Field from "core/models/Field";
import CollectionTableView from "core/views/CollectionTableView";
import OrganizationCollection from "app/models/OrganizationCollection";
import User from "app/models/User";
import UserCollection from "app/models/UserCollection";
import DetailView from "app/views/user/Details";
import EditView from "app/views/admin/users/Edit";
import CreateView from "app/views/user/_Form";
import ModelOperations from "core/operations/ModelOperations";
import NavigationOperations from "core/operations/NavigationOperations";
import ValueCollections from "app/models/ValueCollections";
import sendCreationNotification from "app/operations/send-creation-notification";
import RequestUtils from "app/utils/RequestUtils";
import session from "app/Session";
import app from "app/App";

export default RouterBase.extend({
  root: "/admin/users",
  initialize: function (options) {
    RouterBase.prototype.initialize.apply(this, arguments);
  },

  load: function () {
    this.collection = new UserCollection([]);
    this.organizations = new OrganizationCollection([]);

    return $.when(
      RequestUtils.fetchToPromise(this.collection),
      RequestUtils.fetchToPromise(this.organizations)
    );
  },

  routes: {
    "admin/users": "list",
    // "admin/users/Create": "create",
    "admin/users/Details/:id": "details",
    "admin/users/Edit/:id": "edit",
  },

  routerSettings: {
    title: "Users",
  },

  /**
   * Renders a list of users.
   */
  list: function () {
    var self = this;

    var fields = [
      new Field(User.fields["Username"]).decorate({
        viewOptions: {
          type: "link",
          linkUrl: self.root.substring(1) + "/Details", //substring because we don't want a slash in there
          linkField: "Username",
          linkDefaultText: "(view)",
        },
        id: "id",
        name: "id",
        filterable: "Username",
        sortable: "Username",
      }),
      new Field(User.fields["Name"]).decorate({
        editor: "text",
        name: "fullName",
        id: "fullName",
      }),
      new Field({
        id: "Organization",
        name: "Organization",
        label: "Organization",
        filterable: function (model) {
          var organizations = self.organizations;
          var value;

          var orgId = model.get("Organization");
          var organization = organizations.get(orgId);

          if (organization && organization.attributes) {
            value = organization.attributes.PrimaryName;
            return value;
          }

          return value;
        },
        valueSource: ValueCollections.Organization,
      }),
      new Field(User.fields["PasswordActive"]),
      new Field(User.fields["lastLogin"]),
    ];

    var view = new CollectionTableView({
      collection: this.collection,
      fields: fields,
      allowSave: false,
      allowDelete: false,
      mode: "view",
      className: CollectionTableView.prototype.className + " user-list",
    });

    // app.registerItemAction(
    //   NavigationOperations.createNavigationOperation("Create", "plus", "Create")
    // );

    view.render();

    app.pushView(view);
  },

  /**
   * Renders a view which can be used to create a user.
   */
  create: function () {
    var model = new User({});
    var view = new CreateView({
      organizations: this.organizations.models,
      model: model,
      title: "Create User",
      className: "directory-create",
    });

    view.render();

    app.registerNavigationAction("back");
    app.registerItemAction(
      ModelOperations.create("User", view.view, this.collection, true),
      model
    );

    app.pushView(view);
  },

  /**
   * Renders a view which shows user details.
   * @param  {string} id The ID of the user to display.
   */
  details: function (id) {
    var model = this.collection.get(id);
    var view = new DetailView({
      model: model,
    });

    function rerender() {
      if (view) {
        view.render();
      }
    }

    rerender();

    app.registerNavigationAction("back");

    if (session.user.id == model.id || session.hasRole("admin")) {
      app.registerItemAction(
        NavigationOperations.createNavigationOperation(
          "Edit",
          "pencil",
          "Edit/" + model.id,
          true
        )
      );
      // // app.registerItemAction(sendCreationNotification, model);

      // sendCreationNotification.on(sendCreationNotification.id, rerender);
      // this.once("leave", function () {
      //   sendCreationNotification.off(sendCreationNotification.id, rerender);
      // });
    }

    app.pushView(view);
  },

  /**
   * Renders a view which can be used to modify a user.
   * @param  {string} id The ID of the user to modify.
   */
  edit: function (id) {
    var model = this.collection.get(id);
    var view = new EditView({
      organizations: this.organizations.models,
      model: this.collection.get(id),
    });

    this.doneLoading();
    view.render();

    app.registerNavigationAction("back");

    if (session.hasRole("admin")) {
      app.registerItemAction(
        ModelOperations.destroy("User", this.collection),
        model
      );
    }

    app.registerItemAction(ModelOperations.save("User", view), model);

    app.setLayout("Wide").done(function () {
      app.pushView(view);
      _.delay(_.bind(view.delegateEvents, view), 1000);
    });
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/routers/admin/Users.js
// module id = 611
// module chunks = 1